import { KeyboardEvent, useState } from 'react';
import { Content, useContent } from 'src/contexts/ContentContext';
import { Button, Stack, TextArea } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './ReachProSupportCaseChatInput.css';

interface ReachProSupportCaseChatInputProps {
  onSend: (message: string) => void;
  isLoading?: boolean;
}

export function ReachProSupportCaseChatInput({
  onSend,
  isLoading,
}: ReachProSupportCaseChatInputProps) {
  const [message, setMessage] = useState('');

  const handleSend = () => {
    if (message.trim()) {
      onSend(message.trim());
      setMessage('');
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const typeYourMessageHere = useContent(ContentId.TypeYourMessageHere);

  return (
    <div className={styles.inputContainer}>
      <Stack direction="column" alignItems="end" gap="l" width="full">
        <TextArea.Root>
          <TextArea.Area
            maxLength={2000}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={typeYourMessageHere}
            disabled={isLoading}
          />
        </TextArea.Root>
        <Button onClick={handleSend} disabled={!message.trim() || isLoading}>
          <Content id={ContentId.Reply} />
        </Button>
      </Stack>
    </div>
  );
}
